export default __webpack_public_path__ + "496c1f4e559ecd5f4d0b825da031f6d4.svg";